export default __webpack_public_path__ + "static/media/AspenTech.6389cb04.png";